/**
 * User mode enumeration matching backend values
 */
export enum UserMode {
  Simple = 1,
  Advanced = 2
}
